export enum EStyles {
	percent = '%',
	plus = '+',
	slash = '/',
	comma = ',',
	commaSpace = ', ',
	colon = ':',
	dot = '.',
	emptyQuote = '',
	hyphen = '-',
	underscore = '_',
	space = ' ',
	hash = '#',
	text = 'text',
	none = 'none',
	off = 'off',
	false = 'false',
	string = 'string',
	auto = 'auto',
}

export enum EColors {
	primary = 'primary',
	secondary = 'secondary',
	background = 'background',
	inputBackground = 'input-background',
	selectedBackground = 'selected-background',
	text = 'text',
	medium = 'medium',
	light = 'light',
	icon = 'icon',
	mapRoute = 'map-route',
	error = 'error',
}
